import _ from 'lodash';
import {createSelector} from 'reselect';

import {VacationResponderModel} from '../../../models/api/vacationResponderModel';
import {AppState} from '../../appState';
import {ResourceMap} from '../../appTypes';
import {getUserNamespace} from '../teammates/teammatesSelectors';

export function getVacationResponders(state: AppState): ResourceMap<VacationResponderModel> {
  return state.data.vacationResponders;
}

export const getFlatVacationResponders = createSelector([getVacationResponders], (vacationResponders) =>
  _(vacationResponders).values().compact().value(),
);

export const getFlatVacationRespondersCount = createSelector(
  getFlatVacationResponders,
  (flatVacationResponders) => flatVacationResponders?.length || 0,
);

export const getRespondersByNamespace = createSelector(getFlatVacationResponders, (vacationResponders) =>
  _(vacationResponders)
    .groupBy((v) => v.namespace)
    .value(),
);

export const getUserOwnedResponders = createSelector(
  [getRespondersByNamespace, getUserNamespace],
  (gespondersByNamespace, userNamespace) => gespondersByNamespace[userNamespace],
);
